module.exports = __webpack_public_path__ + "68d3fcdbd2242ed654dce0acb6c881ad.woff2";